import { ParamsWithPagination } from '@/types/api';

import { ProductionCenterFilters } from '../types';

export const productionCenterQueryKeys = {
  all: ['productionCenters'] as const,
  lists: () => [...productionCenterQueryKeys.all, 'lists'] as const,
  list: (filters?: ParamsWithPagination<ProductionCenterFilters>) =>
    [...productionCenterQueryKeys.all, 'lists', filters] as const,
};
